export default function Footer() {
    return <footer className="py-1">
      <p className="text-center text-white mt-1 ">
        UV - 2025, All Rights Reserved
      </p>
    </footer>
}